import dayjs from "dayjs";

export const obtenerFechasIniFInAno = (year) => {



    let fechaInicioMesActual = dayjs(new Date(year, 0, 1))
    let fechaFinMesActual = dayjs(new Date(year, 1, 0, 23, 59, 59))


    let arr = []


    for (let j = 0; j < 12; j++) {
        let fechaInicio = fechaInicioMesActual.add(j, 'month')
        let fechaFin = fechaFinMesActual.add(j, 'month')

        let obj = {
            fechaInicio: fechaInicio.valueOf(),
            fechaFin: fechaFin.valueOf()
        }
        arr.push(obj)

    }


    return arr
}